<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="card card-shadow list-card">
          <div class="container-fluid">
            <div class="row card-body pb-0">
              <div class="col-8 text-left">
                <div id="shopping-list-name">
                  <h5 class="card-title">{{ list.name }}</h5>
                </div>
              </div>
              <div class="col-4 text-right">
                <b-button
                  :variant="settings ? 'primary' : 'secondary'"
                  size="sm"
                  title="Settings"
                  @click="showSettings"
                >
                  <i class="fas fa-cog"></i>
                </b-button>
              </div>
            </div>
            <div
              class="row card-body pt-3 pb-0"
              v-if="type === 'shopping' && settings"
            >
              <div class="col-sm-6 col-xs-12 text-right">
                <b-form-checkbox
                  v-model="list.move_purchased"
                  class="pt-2"
                  @change="updatePantryList"
                  >Move purchased items to pantry list</b-form-checkbox
                >
              </div>
              <div class="col-sm-6 col-xs-12 text-left">
                <b-form-select
                  v-model="list.pantry_list"
                  :options="pantryListOptions"
                  placeholder="e.g. My pantry list"
                  @change="updatePantryList"
                ></b-form-select>
              </div>
            </div>
            <div
              class="row card-body pt-3 pb-3 px-5 mx-1 d-flex justify-content-center border-bottom"
              v-if="settings"
            >
              <b-button
                variant="outline-success"
                class="mx-1"
                @click="markAllPurchased"
                v-if="type === 'shopping'"
                ><i class="far fa-check-square"></i> Mark All Items
                Purchased</b-button
              >
              <b-button variant="outline-danger" class="mx-1" @click="deleteAll"
                ><i class="far fa-trash-alt"></i> Delete All Items</b-button
              >
            </div>
            <div
              id="add-item"
              class="row card-body pt-3 pb-0 pl-5 pr-5"
              v-if="type === 'shopping'"
            >
              <div class="autocomplete input-group">
                <autocomplete
                  ref="autocomplete"
                  class="autocomplete-wrapper"
                  placeholder="e.g. Lean Ground Beef"
                  :search="searchFood"
                  :get-result-value="getFoodValue"
                  @change="updateFood"
                ></autocomplete>
                <div class="input-group-append">
                  <button
                    id="list-add-item"
                    class="btn btn-outline-success"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Add Item"
                    @click="addItem"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <draggable
                  tag="div"
                  class="list-group"
                  handle=".handle"
                  :list="list.items"
                  @end="updateItems"
                >
                  <b-list-group-item
                    class="list-item-row list-group-item"
                    v-for="(item, index) in list.items"
                    :key="index"
                  >
                    <div>
                      <div class="handle list-handle">
                        <i class="fas fa-grip-vertical"></i>
                      </div>
                      <div class="d-flex justify-content-between">
                        <span
                          @click="expandItem(index)"
                          :class="
                            item.purchased
                              ? 'strikethrough cursor-pointer item-span'
                              : 'cursor-pointer item-span'
                          "
                          >{{ item.food.name }}
                          <small v-if="item.amount && item.amount > 0"
                            ><i
                              >{{ formatAmount(item.amount) }}
                              {{ formatUnit(item.unit) }}</i
                            ></small
                          ></span
                        >
                        <div v-if="type === 'shopping'">
                          <b-form-checkbox
                            v-model="item.purchased"
                            @change="updateItems($event, index)"
                          ></b-form-checkbox>
                        </div>
                        <div v-if="type === 'pantry'">
                          {{ formatPurchaseDate(item.purchase_date) }}
                        </div>
                        <div v-if="type === 'pantry'">
                          <b-button
                            variant="outline-danger"
                            size="sm"
                            class="ml-2"
                          >
                            <i class="far fa-trash-alt"></i>
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="itemsExpanded[index]"
                      class="d-flex w-100 justify-content-between py-3"
                    >
                      <div class="input-group pr-5">
                        <input
                          name="amount"
                          type="text"
                          class="form-control input-amount"
                          placeholder="e.g. 1"
                          v-model="itemAmount.amount"
                        />
                        <div class="input-group-append">
                          <autocomplete
                            :search="searchUnits"
                            :get-result-value="getUnitValue"
                            :default-value="formatUnit(item.unit)"
                            :index="index"
                            overwrite-class="list-unit"
                            placeholder="e.g. Ounces (oz)"
                            @change="updateUnit"
                          ></autocomplete>
                          <b-button
                            variant="outline-success"
                            @click="saveAmount(index)"
                          >
                            <i class="far fa-save"></i>
                          </b-button>
                        </div>
                      </div>
                      <b-button
                        variant="outline-danger"
                        @click="deleteItem(index)"
                        size="sm"
                        v-if="type !== 'pantry'"
                      >
                        <i class="far fa-trash-alt"></i>
                      </b-button>
                    </div>
                    <div
                      v-if="itemsExpanded[index]"
                      class="d-flex w-100 justify-content-center"
                    >
                      <b-button
                        variant="secondary"
                        size="sm"
                        class="px-5 py-0"
                        @click="closeItem(index)"
                      >
                        <i class="fas fa-angle-double-up"></i>
                      </b-button>
                    </div>
                  </b-list-group-item>
                </draggable>
              </div>
            </div>
            <div class="row">
              <div class="col text-left">
                <div class="card-body">
                  <b-button
                    variant="outline-primary"
                    class="mr-2"
                    :to="{ name: 'lists', params: { type: type } }"
                    ><i class="far fa-arrow-alt-circle-left"></i> Back</b-button
                  >
                  <b-button
                    variant="outline-danger"
                    v-b-modal.modal_list_delete
                  >
                    <i class="far fa-trash-alt"></i> Delete List
                  </b-button>

                  <b-modal
                    id="modal_list_delete"
                    title="Delete List"
                    header-bg-variant="danger"
                    header-text-variant="light"
                    ok-title="Delete"
                    ok-variant="danger"
                    @ok="deleteList()"
                  >
                    <p>
                      Are you sure you want to delete this list?
                    </p>
                  </b-modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FirebaseMixin from "@/mixins/Firebase";
import UtilsMixin from "@/mixins/Utils";
import Autocomplete from "@/components/Autocomplete";
import moment from "moment";
import draggable from "vuedraggable";
import Fraction from "fraction.js";

export default {
  name: "ListView",
  mixins: [FirebaseMixin, UtilsMixin],
  components: { autocomplete: Autocomplete, draggable: draggable },
  data() {
    return {
      ref: "lists",
      bind: ["units", "food"],
      refkey: null,
      list: {
        name: "",
        date: "",
        items: [],
        move_purchased: false,
        pantry_list: ""
      },
      itemAmount: {
        amount: null,
        unit: {
          name: ""
        }
      },
      itemsExpanded: [],
      type: "shopping",
      foodItem: "",
      pantryLists: [],
      settings: false
    };
  },
  computed: {
    ...mapState(["isAuthenticated", "userProfile"]),
    ...mapGetters([
      "userNumberFormat",
      "familyShoppingDay",
      "familyFood",
      "userUnitSystem"
    ]),
    familyKey() {
      return this.userProfile.family_key;
    },
    listDate() {
      return moment().day(this.familyShoppingDay) > moment()
        ? moment().day(this.familyShoppingDay)
        : moment()
            .day(this.familyShoppingDay)
            .add(1, "weeks");
    },
    foodList() {
      let food;
      try {
        food = this.createUniqueList(this.food, this.familyFood);
      } catch (e) {
        console.log(e);
        food = [];
      }
      return food;
    },
    pantryListOptions() {
      return this.sourceOptions(this.pantryLists);
    }
  },
  watch: {
    familyKey: {
      immediate: true,
      handler(family_key) {
        console.log(family_key);
        if (family_key !== null && this.refkey !== null) {
          this.bindObject(
            "lists/" + family_key + "/" + this.type,
            this.refkey,
            "list"
          );
        }
        if (family_key !== null) {
          this.bindObject(
            "lists/" + family_key + "/pantry",
            null,
            "pantryLists"
          );
        }
      }
    },
    refkey: {
      immediate: true,
      handler(key) {
        if (key !== null && this.familyKey !== null) {
          this.bindObject(
            "lists/" + this.familyKey + "/" + this.type,
            key,
            "list"
          );
        }
      }
    },
    list: {
      immediate: true,
      handler(list) {
        list.items = !Array.isArray(list.items) ? [] : list.items;
        list.items.forEach((item, index) => {
          if (!(index in this.itemsExpanded)) {
            this.$set(this.itemsExpanded, index, false);
          }
          if (!("unit" in item)) {
            item.unit = {
              name: ""
            };
          }
        });
      }
    }
  },
  methods: {
    searchFood(input) {
      if (input.length < 1) {
        return [];
      }
      return this.foodList.filter(food => {
        return food.name.toLowerCase().startsWith(input.toLowerCase());
      });
    },
    getFoodValue(result) {
      return result.name;
    },
    updateFood(value) {
      const food = { ...value };
      this.foodItem = food;
    },
    searchUnits(input) {
      if (input.length < 1) {
        return [];
      }
      return this.units[this.userUnitSystem].filter(unit => {
        return (
          unit.name.toLowerCase().startsWith(input.toLowerCase()) ||
          unit.label.toLowerCase().startsWith(input.toLowerCase())
        );
      });
    },
    formatUnit(unit) {
      const label = unit.label ? unit.label : "";
      const formatted = unit.name + " (" + label + ")";
      console.log(formatted);
      return formatted.replace(" ()", "");
    },
    getUnitValue(result) {
      return this.formatUnit(result);
    },
    updateUnit(value) {
      const unit = { ...value };
      this.itemAmount.unit = unit;
    },
    addItem() {
      this.closeAllItems();
      const list = { ...this.list };
      list.items.push({
        food: { ...this.foodItem },
        unit: { name: "" }
      });
      this.updateObject(
        "lists/" + this.familyKey + "/" + this.type + "/" + this.refkey,
        null,
        list,
        true
      )
        .then(() => {
          document.querySelector(".autocomplete-input").value = "";
          console.log(this.$refs.autocomplete);
          this.$refs.autocomplete.$children[0].core.setValue("");
        })
        .catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred while updating the list. Please try again later."
          );
        });
    },
    updateItems(value = null, index = null) {
      this.closeAllItems();
      const list = { ...this.list };
      if (value !== null && index !== null) {
        list.items[index].purchased = value;
      }
      console.log(list);
      this.updateObject(
        "lists/" + this.familyKey + "/" + this.type + "/" + this.refkey,
        null,
        list,
        true
      )
        .then(() => {
          // If purchased, add item to pantry list
          if (
            value !== null &&
            index !== null &&
            this.list.move_purchased &&
            this.list.pantry_list &&
            list.items[index] &&
            list.items[index].purchased
          ) {
            this.getObjectSnapshot(
              "lists/" + this.familyKey + "/pantry/" + this.list.pantry_list
            ).then(pantryList => {
              pantryList.items = !Array.isArray(pantryList.items)
                ? []
                : pantryList.items;
              let item = list.items[index];
              delete item.purchased;
              item.purchase_date = Date.now();
              pantryList.items.push(item);
              this.updateObject(
                "lists/" + this.familyKey + "/pantry/" + this.list.pantry_list,
                null,
                pantryList,
                true
              ).catch(error => {
                console.log(error);
              });
            });
          }
        })
        .catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred while updating the list. Please try again later."
          );
        });
    },
    showSettings() {
      this.settings = this.settings ? false : true;
    },
    markAllPurchased() {
      const list = { ...this.list };
      const notPurchased = [];
      list.items.forEach(item => {
        if (!item.purchased) {
          item.purchased = true;
          let pantryItem = { ...item };
          delete pantryItem.purchased;
          pantryItem.purchase_date = Date.now();
          notPurchased.push(pantryItem);
        }
      });
      console.log(list);
      this.updateObject(
        "lists/" + this.familyKey + "/" + this.type + "/" + this.refkey,
        null,
        list,
        true
      )
        .then(() => {
          // If purchased, add item to pantry list
          if (this.list.move_purchased && this.list.pantry_list) {
            this.getObjectSnapshot(
              "lists/" + this.familyKey + "/pantry/" + this.list.pantry_list
            ).then(pantryList => {
              pantryList.items = !Array.isArray(pantryList.items)
                ? []
                : pantryList.items;
              pantryList.items.push(...notPurchased);
              this.updateObject(
                "lists/" + this.familyKey + "/pantry/" + this.list.pantry_list,
                null,
                pantryList,
                true
              ).catch(error => {
                console.log(error);
              });
            });
          }
        })
        .catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred while updating the list. Please try again later."
          );
        });
    },
    deleteAll() {
      const list = { ...this.list };
      list.items = [];
      console.log(list);
      this.updateObject(
        "lists/" + this.familyKey + "/" + this.type + "/" + this.refkey,
        null,
        list,
        true
      ).catch(error => {
        console.log(error);
        window.toastr.error(
          "An error occurred while updating the list. Please try again later."
        );
      });
    },
    deleteItem(index) {
      this.closeAllItems();
      this.$set(this.itemAmount, "amount", null);
      this.$set(this.itemAmount, "unit", {
        name: ""
      });
      const list = { ...this.list };
      list.items.splice(index, 1);
      console.log(list);
      this.updateObject(
        "lists/" + this.familyKey + "/" + this.type + "/" + this.refkey,
        null,
        list,
        true
      ).catch(error => {
        console.log(error);
        window.toastr.error(
          "An error occurred while updating the list. Please try again later."
        );
      });
    },
    expandItem(index) {
      this.closeAllItems();
      const amount = this.list.items[index].amount;
      const unit = this.list.items[index].unit;
      this.$set(this.itemAmount, "amount", amount);
      this.$set(this.itemAmount, "unit", unit);
      this.$set(this.itemsExpanded, index, true);
    },
    closeItem(index) {
      this.$set(this.itemsExpanded, index, false);
    },
    closeAllItems() {
      this.list.items.forEach((item, index) => {
        this.$set(this.itemsExpanded, index, false);
      });
    },
    formatAmount(amount) {
      if (this.userNumberFormat === "fractions") {
        const f = new Fraction(amount);
        amount = f.toFraction(true);
      }
      return amount;
    },
    saveAmount(index) {
      const amount = this.itemAmount.amount;
      const unit = this.itemAmount.unit;
      const list = { ...this.list };
      list.items[index].amount = amount;
      list.items[index].unit = unit;

      console.log(list);
      this.updateObject(
        "lists/" + this.familyKey + "/" + this.type + "/" + this.refkey,
        null,
        list,
        true
      )
        .then(() => {
          this.$set(this.list.items[index], "amount", amount);
          this.$set(this.list.items[index], "unit", unit);
          this.closeItem(index);
          this.$set(this.itemAmount, "amount", null);
          this.$set(this.itemAmount, "unit", {
            name: ""
          });
        })
        .catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred while updating the list. Please try again later."
          );
        });
    },
    updatePantryList() {
      this.$nextTick().then(() => {
        const list = { ...this.list };
        this.updateObject(
          "lists/" + this.familyKey + "/" + this.type + "/" + this.refkey,
          null,
          list,
          true
        ).catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred while updating the list. Please try again later."
          );
        });
      });
    },
    formatPurchaseDate(date) {
      return (
        moment(date).format("M/D/YYYY") + " (" + moment(date).fromNow() + ")"
      );
    },
    deleteList() {
      this.deleteObject(
        "lists/" + this.familyKey + "/" + this.type + "/" + this.refkey
      )
        .then(() => {
          this.navigate("lists", { type: this.type });
          window.toastr.success("List deleted successfully.");
        })
        .catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred while updating the list. Please try again later."
          );
        });
    }
  },
  created() {
    this.type = this.$route.params.type;
    this.refkey = this.$route.params.id;
  }
};
</script>

<style>
.list-card {
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

#btnNewItem {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.list-handle {
  width: 30px;
  height: 28px;
  float: left;
  cursor: pointer;
}

.item-span {
  width: calc(100% - 24px);
}

.autocomplete-wrapper {
  width: calc(100% - 40px);
}

.autocomplete-input {
  width: 100%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.list-unit {
  max-width: 185px;
  border-radius: 0 !important;
}

.list-unit-input {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0 !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  max-width: 185px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.list-unit-input:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.list-unit-result-list {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  max-width: 185px;
  list-style-type: none;
  cursor: pointer;
}

.list-unit-result-list:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.input-amount {
  max-width: 180px;
}

.strikethrough {
  text-decoration: line-through;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
